import React, { useMemo } from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";
import sessionExamsHelper from "../helper";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import moment from "moment";
import { formatDateOnlyBg } from "server/formatting/formatDateBg";

const SessionExamDates = ({ sessionDateRange }) => {
  const startTime = useWatch({ name: "startTime" });
  const endTime = useWatch({ name: "endTime" });

  const { minDate, maxDate } = useMemo(() => {
    if (!sessionDateRange) return { minDate: null, maxDate: null };

    return { minDate: sessionDateRange.startsOn, maxDate: sessionDateRange.extendedEndsOn || sessionDateRange.endsOn };
  }, [sessionDateRange]);

  const shouldDisableDate = date => {
    if (!sessionDateRange) return false;

    const momentDate = moment(date);
    const start = moment(sessionDateRange.startsOn);
    const end = moment(sessionDateRange.extendedEndsOn || sessionDateRange.endsOn);

    return momentDate.isBefore(start, "day") || momentDate.isAfter(end, "day");
  };

  return (
    <Card sx={{ width: "100%" }}>
      <CardContent>
        <Grid
          container
          spacing={1}
        >
          <Typography
            fontWeight="bold"
            color="primary"
          >
            Дни на провеждане на изпит
          </Typography>
        </Grid>
        <Grid
          container
          spacing={1}
        >
          <Grid
            item
            xs={12}
            md={6}
            lg={3}
          >
            <CustomDateInput
              source="date"
              label="Дата"
              required={true}
              minDate={minDate}
              maxDate={maxDate}
              shouldDisableDate={shouldDisableDate}
              disabled={!sessionDateRange}
              // readOnly={isExamPassed || loading}
            />
            {sessionDateRange && (
              <Typography
                variant="caption"
                color="text.secondary"
              >
                (Сесията е от {formatDateOnlyBg(sessionDateRange.startsOn)} до{" "}
                {formatDateOnlyBg(sessionDateRange.extendedEndsOn || sessionDateRange.endsOn)})
              </Typography>
            )}
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            lg={2}
          >
            <CustomTimeOnlyInput
              source="startTime"
              label="Начало"
              required={true}
              validate={() => sessionExamsHelper.validateTimeSlots({ startTime, endTime })}
              // defaultDateValue={currentExamStartTimestamp}
              // readOnly={isExamPassed || loading}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            lg={2}
          >
            <CustomTimeOnlyInput
              source="endTime"
              label="Край"
              required={true}
              validate={() => sessionExamsHelper.validateTimeSlots({ startTime, endTime })}
              // defaultDateValue={currentExamStartTimestamp}
              // readOnly={isExamPassed || loading}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SessionExamDates;
